<template>
  <div v-if="application.actions.some(action => [
      'APPLICATIONS_RETURN_ACTION',
      'APPLICATIONS_ACCEPT_ACTION',
      'APPLICATIONS_REFUSE_ACTION',
      'APPLICATIONS_RETURN_REMARKS_ACTION',
      'APPLICATIONS_ACCEPT_REMARKS_ACTION',
      'APPLICATIONS_AGREEMENT_REMARKS_SEND_ACTION',
      'APPLICATIONS_REMARKS_SEND_ACTION',
      'APPLICATIONS_PAYMENT_CONFIRM_ACTION',
      'APPLICATIONS_CONCLUSION_SEND_ACTION'].includes(action.constName))"
       class="reslolution__action__buttons space__between">
<!--    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_REFUSE_ACTION')"-->
<!--            type="button" class="button red__lighter"-->
<!--            @click="$emitter.emit('openApplicationRefuseModal', application)">-->
<!--      {{ application.actions.find(action => action.constName === 'APPLICATIONS_REFUSE_ACTION').name }}-->
<!--    </button>-->
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_RETURN_ACTION')"
            type="button" class="button orange__medium button--centered"
            @click="$emitter.emit('openApplicationReturnModal', application)">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_RETURN_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_ACCEPT_ACTION')"
            type="button" class="button button__icon--left green__lighter show__add__user"
            @click="$emitter.emit('openApplicationAcceptModal', application)">
      <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
        <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
      </svg>
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_ACCEPT_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_RETURN_REMARKS_ACTION')"
            type="button" class="button orange__medium"
            @click="$emitter.emit('openApplicationReturnRemarksModal', application)">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_RETURN_REMARKS_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_ACCEPT_REMARKS_ACTION')"
            type="button" class="button button__icon--left green__lighter show__add__user"
            @click="acceptApplicationRemark">
      <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
        <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
      </svg>
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_ACCEPT_REMARKS_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_AGREEMENT_REMARKS_SEND_ACTION')"
            type="button" class="button orange__medium"
            @click="sendApplicationAgreementRemark">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_AGREEMENT_REMARKS_SEND_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_REMARKS_SEND_ACTION')"
            type="button" class="button orange__medium"
            @click="sendApplicationRemark">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_REMARKS_SEND_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_PAYMENT_CONFIRM_ACTION')"
            type="button" class="button button__icon--left green__lighter show__add__user"
            @click="this.$emitter.emit('openConfirmPaymentsModal', application)">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_PAYMENT_CONFIRM_ACTION').name }}
    </button>
    <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_CONCLUSION_SEND_ACTION')"
            type="button" class="button button__icon--left green__lighter show__add__user"
            @click="sendApplicationConclusion">
      {{ application.actions.find(action => action.constName === 'APPLICATIONS_CONCLUSION_SEND_ACTION').name }}
    </button>

    <RefuseModal/>
    <ReturnModal/>
    <AcceptModal/>
    <ReturnRemarksModal/>
    <ConfirmPaymentsModal/>
  </div>
</template>
<script>
import RefuseModal from "./modals/RefuseModal.vue";
import ReturnModal from "./modals/ReturnModal.vue";
import AcceptModal from "./modals/AcceptModal.vue";
import ReturnRemarksModal from "./modals/ReturnRemarksModal.vue";
import applicationApi from "../../../api/employee/application";
import ConfirmPaymentsModal from "./modals/ConfirmPaymentsModal.vue";
export default {
  props: {
    application: Object
  },
  components: {
    RefuseModal,
    ReturnModal,
    AcceptModal,
    ReturnRemarksModal,
    ConfirmPaymentsModal,
  },
  methods: {
    acceptApplicationRemark() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .acceptApplicationRemark(this.application.id)
          .then(() => {
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
        this.$snotify.error(error.response.data.message)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
    sendApplicationAgreementRemark() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .sendApplicationAgreementRemark(this.application.id)
          .then(() => {
            this.$emitter.emit('refreshStatistics')
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
        this.$snotify.error(error.response.data.message)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
    sendApplicationRemark() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .sendApplicationRemark(this.application.id)
          .then(() => {
            this.$emitter.emit('refreshStatistics')
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
        this.$snotify.error(error.response.data.message)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
    sendApplicationConclusion() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .sendApplicationConclusion(this.application.id)
          .then(() => {
            this.$emitter.emit('refreshStatistics')
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).catch(error => {
        this.$snotify.error(error.response.data.message)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
  }
}
</script>